module.exports = __webpack_public_path__ + "assets/img/41.0d5780c3.png";